import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
const data = [
  { month: '1月', 销售额: 4000, 利润: 2400 },
  { month: '2月', 销售额: 3000, 利润: 1398 },
  { month: '3月', 销售额: 2000, 利润: 9800 },
  { month: '4月', 销售额: 2780, 利润: 3908 },
  { month: '5月', 销售额: 1890, 利润: 4800 },
  { month: '6月', 销售额: 2390, 利润: 3800 },
  { month: '7月', 销售额: 3490, 利润: 4300 },
];
export default function LineChartExample() {
  return (
    <div className="w-full min-h-[60vh] sm:min-h-[70vh] lg:h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4 sm:p-8">
      <div className="bg-white rounded-xl shadow-2xl p-4 sm:p-8 w-full max-w-4xl">
        <h2 className="text-xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center">
          月度销售数据分析
        </h2>
        <div className="h-[260px] sm:h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="销售额"
                stroke="#3b82f6"
                strokeWidth={3}
                dot={{ fill: '#3b82f6', r: 5 }}
                activeDot={{ r: 8 }}
              />
              <Line
                type="monotone"
                dataKey="利润"
                stroke="#10b981"
                strokeWidth={3}
                dot={{ fill: '#10b981', r: 5 }}
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <p className="text-gray-600 text-center mt-4">
          将鼠标悬停在数据点上查看详细信息
        </p>
      </div>
    </div>
  );
}
